import MinutesSaved from './minutesSaved';

export default MinutesSaved;